export default __webpack_public_path__ + "static/media/KayleeOsterberger.d92eba9f.jpg";